import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import classNames from '@/utils/classNames';
import type { ComponentPropsWithRef } from 'react';
import styles from './ToolbarControl.module.css';
type ToolbarControlProps = ComponentPropsWithRef<'button'> & ComponentPropsWithRef<typeof Button>;
export const ToolbarControl = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames(styles.control, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Button className={t1} kind="secondary" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};